import React from 'react';
import { toast } from 'react-toastify';

class SpecialProgramForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      program: 0
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({ program: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    const program = this.state.program;
    if (program > 0) {
      this.props.onSubmit(program);
      this.setState({ program: 0 });
    }
    else {
      toast.error('Please select program.');
    }
  }

  render() {
    const {
      programOptions,
    } = this.props

    return (
      <form method="post" className="well padding-bottom-10" onSubmit={this.handleSubmit} >
        <div className="row form-group">
          <div className="col-md-1">
          </div>
          <div className="col-md-8">
            <label className="control-label"><strong>Program: </strong></label>
            {programOptions && (
              <select onChange={this.handleChange} value={this.state.reason} className="form-control">
                <option value="0">Select</option>
                {programOptions.map((option, i) => (
                  <option key={i} value={option.id}>
                    {`${option.name}`}
                  </option>
                ))}
              </select>
            )}
          </div>
          <div className="col-md-2">
            <br/>
            <button type="submit" className="btn btn-sm btn-primary">
              Save
					</button>
          </div>
          <div className="col-md-1">
          </div>
        </div>
      </form>
    );
  }
}
export default SpecialProgramForm;



// WEBPACK FOOTER //
// ./src/routes/management/components/SpecialProgramForm.js